import clientAxios from '../clients/clientAxios';

export const getFirstInstallmentSales = async (year, month) => {
  try {
    const response = await clientAxios.get('/graph/first-installment', {
      params: { year, month }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error de conexión' };
  }
};